import React from 'react';

import styles from './styles/view-button-box.module.css';

import {ReactComponent as ChartActive} from '../../assets/chat/chart-active.svg';
import {ReactComponent as Chart} from '../../assets/chat/chart.svg';
import {ReactComponent as TableActive} from '../../assets/chat/table-active.svg';
import {ReactComponent as Table} from '../../assets/chat/table.svg';

export default function ViewButtonBox({ answerId, viewType, updateViewType }) {
    const changeViewType = (type) => {
        updateViewType(answerId, type);
    };

    return (
        <div className={styles.wrapper}>
            <button className={viewType === 'TABLE' ? `${styles.btnInactive} ${styles.btnActive}` : `${styles.btnInactive}`}
                    onClick={() => changeViewType('TABLE')}
            >
                    {viewType === 'TABLE' ? <TableActive /> : <Table />}
            </button>
            <button className={viewType === 'CHART' ? `${styles.btnInactive} ${styles.btnActive}` : `${styles.btnInactive}`}
                    onClick={() => changeViewType('CHART')}
            >
                {viewType === 'CHART' ? <ChartActive /> : <Chart />}
            </button>
        </div>
    );
}
